<template>
    <BaseDialog
        :showDialog="showDistributionSearchDialog"
        maxDialogWidth="600"
        maxCardHeight="900"
        headline="lang_PUBLISHING_WORKS_CAPTION_DISTRIBUTION_SEARCH"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid >

                <v-row>  
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Target"
                            :items="$alvPlugin.cwrSocieties(false, alvqa + '-cwr-dropdown-recipient')"
                            :label="$t('lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_TARGET')"
                            :withMargin="false"
                            :selection="true"
                            :alvqa="alvqa + '-cwr-dropdown-recipient'"
                        />
                    </v-col>
                </v-row>

                <v-row>  
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Function"
                            :items="functionItems"
                            :label="$t('lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_FUNCTION')"
                            :withMargin="false"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-function'"
                        />
                    </v-col>
                </v-row>

                <v-row>  
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Status"
                            :items="statusItems"
                            :label="$t('lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_STATUS')"
                            :withMargin="false"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-status'"
                        />
                    </v-col>
                </v-row>

                <v-row>  
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="From"
                            :withMargin="false"
                            :label="$t('lang_GENERIC_CAPTION_PERIOD_FROM')"  
                            :alvqa="alvqa + '-datepicker-from'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="To"
                            :withMargin="false"
                            :label="$t('lang_GENERIC_CAPTION_PERIOD_TO')"  
                            :alvqa="alvqa + '-datepicker-to'"
                        />
                    </v-col>
                </v-row>

            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseRegions from '@/components/_base/BaseRegions'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'

import {    
        DropdownDistributionSearchFunctions, 
        DropdownDistributionSearchStatus,
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "DistributionSearchDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseCheckbox,
        BaseEditPageDropdown,
        BaseRegions,
        BaseIcon,
        BaseEditPageDatePicker,
    },
    data() {
        return {
            context: "DistributionSearch",
            alvqa: 'publishing-works-list-dialog-distribution-search',
        }
    },
    computed: {
        showDistributionSearchDialog: {
            get() { return this.$store.getters.getShowDistributionSearchDialog },
            set(show) { this.$store.commit('setShowDistributionSearchDialog', show) }
        },
        functionItems() { return DropdownDistributionSearchFunctions },
        statusItems() { return DropdownDistributionSearchStatus },
    },
    watch: {
        showDistributionSearchDialog(newVal) {
            if (newVal) {
                this.$store.dispatch('fetchAzSocietiesWhereDirectMember')
            }
        }
    },
    created() {
        this.$store.commit('setSocieties')
    },
    methods: {
        closeDialog() {
            this.showDistributionSearchDialog = false
        },
    }

}
</script>